export default __webpack_public_path__ + "static/media/googleplay.7e6f5ce2.svg";